import * as React from "react";
import {
    makeStyles,
    SelectTabData,
    SelectTabEvent,
    Tab,
    TabList,
    TabValue,
} from "@fluentui/react-components";
import {FormNewRegular, PenSparkle16Regular, TextField16Regular, ClearFormatting16Regular} from "@fluentui/react-icons";
import Modeles from "./Modeles";
import ChampsInserer from "./ChampsInserer";
import ChampsFusion from "./ChampsFusion";
import Correcteur from "./Correcteur";
import {DocumentModel, ZDocumentType} from "../../../utils/models/document.model";

export interface TabsProps {
    document: DocumentModel;
}

const useStyles = makeStyles({
    root: {
        alignItems: "stretch",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        rowGap: "16px",
    },
    tabList: {
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
    },
    tab: {
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        height: "auto",
        minHeight: "36px",
        justifyContent: "flex-start",
        whiteSpace: "normal",
        textAlign: "left",
        overflowWrap: "anywhere",
    },
    panel: {
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
    },
});

const Tabs: React.FC<TabsProps> = (props: TabsProps) => {
    const {document} = props;
    const styles = useStyles();

    const estModeleFacture = document?.Type === ZDocumentType.MODELE_FACTURE;
    const estModeleFusion =
        estModeleFacture ||
        document?.Type === ZDocumentType.MODELE_RELANCE ||
        document?.Type === ZDocumentType.MODELE_DOCUMENT;

    const [selectedValue, setSelectedValue] = React.useState<TabValue>(estModeleFusion ? "champsFusion" : "modeles");

    React.useEffect(() => {
        if (estModeleFusion) {
            setSelectedValue("champsFusion");
        }
    }, [document?.Type, estModeleFusion]);

    const onTabSelect = (_event: SelectTabEvent, data: SelectTabData) => {
        setSelectedValue(data.value);
    };

    return (
        <div className={styles.root}>
            <TabList
                className={styles.tabList}
                selectedValue={selectedValue}
                onTabSelect={onTabSelect}
                vertical
            >
                {estModeleFusion && (
                    <Tab className={styles.tab} value="champsFusion" icon={<TextField16Regular/>}>
                        Champs de fusion
                    </Tab>
                )}
                <Tab className={styles.tab} value="modeles" icon={<PenSparkle16Regular/>}>
                    Modèles (avec Zéphyr)
                </Tab>
                {!estModeleFacture && (
                    <Tab className={styles.tab} value="champsInserer" icon={<FormNewRegular/>}>
                        Champs à insérer
                    </Tab>
                )}
                <Tab className={styles.tab} value="correcteur" icon={<ClearFormatting16Regular/>}>
                    Correcteur
                </Tab>
            </TabList>
            <div className={styles.panel}>
                {selectedValue === "champsFusion" && <ChampsFusion document={document}/>}
                {selectedValue === "modeles" && <Modeles/>}
                {selectedValue === "champsInserer" && !estModeleFacture && <ChampsInserer document={document}/>}
                {selectedValue === "correcteur" && <Correcteur/>}
            </div>
        </div>
    );
};

export default Tabs;
